// LoginPage.jsx
import React from "react";
import WelcomeAnimation from "./WelcomeAnimation";
import useCanonicalUrl from "../hooks/useCanonicalUrl";
import styles from "./LoginPage.module.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const LoginPage = () => {
  useCanonicalUrl("/login");

  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/login`;
  };

  const handleFacebookLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/facebook/login`;
  };

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <div className={styles.animationSection}>
          <WelcomeAnimation />
        </div>

        <div className={styles.taglineSection}>
          <div className={styles.taglineCard}>
            <div className={styles.appName}>
              <span className={styles.jigyasa}>Jigyasa</span>
              <span className={styles.ai}>AI</span>
            </div>
            <div className={styles.tagline}>
              <span className={styles.taglineText}>Where AI Empowers</span>
              <span className={styles.hindi}>Hindi</span>
            </div>

            <h1 className={styles.seoHeroTitle}>
              Improve Hindi reading and writing with Jigyasa AI for Primary
              and Secondary students in Singapore.
            </h1>
            <p className={styles.seoHeroSubtitle}>
              Personalized Hindi comprehension practice with instant AI
              feedback, designed for families and teachers.
            </p>

            <div className={styles.divider}></div>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "20px" }}>
              {/* Google Sign-In */}
              <button className={styles.googleButton} onClick={handleGoogleLogin}>
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                Sign in with Google
              </button>

              {/* Facebook Sign-In */}
              <button className={styles.googleButton} onClick={handleFacebookLogin}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#1877F2">
                  <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
                </svg>
                Sign in with Facebook
              </button>
            </div>

            <p className={styles.trustLine}>
              <span className={styles.trustStrong}>Trusted by families in Singapore</span>
              {" "}— practicing Hindi comprehension every day
            </p>

          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
